import $ from 'jquery';

$(document).ready(function () {
  exampleWidget();
});

function exampleWidget() {
  $('.js-example-widget').each(function () {});
}
